
import TableList from "@components/templates/tablelist";
import compUpdate from "./update.vue";
import {
    HttpGetBlackList,
    HttpBlackListActive,
} from "@/service/carrieraccount.js";
import { mapState, mapGetters } from "vuex";
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    components: {
        compUpdate,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    'EQ_status': null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            warehouseList: [],
            Plugins: { show: true },
            initData: '',
        };
    },
    methods: {
        ajaxRequest: HttpGetBlackList,
        exportQuery() {
            let searchData = {}
            Object.keys(this.formData.search).map(item => {
                console.log(item, this.formData.search[item])
                searchData[`search[${item}]`] = this.formData.search[item]
            });
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/carrierBlackList/batchExport", {
                ...searchData
            }, {
                executor: 'request',
                download: true,
            }).catch(err => {
                // this.$VMessage.error(err.message);
            })
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 800,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case 'exportQuery':
                    this.exportQuery(params)
                    break
                case 'add':
                    this.operate = {
                        title: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'add',
                        showFooter: false
                    }
                    break;
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'edit',
                        showFooter: false
                    }
                    break;
                case 'changeStatus':
                    this.operate = {
                        title: params.status === 0 ? this.$t('fbb.accountmanage.loss_effect', { defaultValue: '失效' }) : this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                        show: true,
                        alert: 'warning',
                        width: 400,
                        showDesc: true,
                        params: {
                            id: params.id
                        },
                        ajaxRequest: HttpBlackListActive,
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                    show: this.handleAuth('fbb.blacklist.edit'),
                    params: id,
                    operate: 'edit'
                }, {
                    label: row.status === 0 ? this.$t('fbb.accountmanage.loss_effect', { defaultValue: '失效' }) : this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                    show: this.handleAuth('fbb.blacklist.edit'),
                    params: {
                        id,
                        status: row.status
                    },
                    operate: 'changeStatus'
                }]
        },
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAll",
            "getBillcusWareList",
            "getSelfmanageorgList",
            "getAlllogProCodeList"
        ]),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    operate: "add",
                    show: this.handleAuth('fbb.blacklist.add'),
                    theme: "primary",
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'exportQuery',
                    show: this.handleAuth('fbb.blacklist.export'),
                    theme: 'success'
                }
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 250px'
            return [
                {
                    label: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'IN_organizationId',
                    show: true,
                    tag: 'Select',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'IN_orgWarehouseCode',
                    show: true,
                    tag: 'Select',
                    options: this.getBillcusWareList.map(item => {
                        return {
                            label: item.label,
                            value: item.attach.code
                        }
                    }),
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.expresspackage.service_code', { defaultValue: '承运商' }),
                    tag: 'Select',
                    show: true,
                    key: 'IN_carrierCode',
                    options: this.getCarrierAll,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.carrieraccount.carrier_group', { defaultValue: '物流产品' }),
                    tag: 'Select',
                    key: 'IN_carrierGroupId',
                    options: this.getAlllogProCodeList,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                },
                {
                    label: this.$t('erp.b2c.hippingMethodCode', { defaultValue: '物流服务' }),
                    tag: 'Input',
                    key: 'CN_carrierServiceCode',
                }
            ]
        },
        columns() {
            return [
                {
                    // show: false,
                    type: 'index',
                    width: 40,
                    align: 'center',
                }, {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                },
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    render: (h, { row }) => {
                        let clientItem = this.getSelfmanageorgList.filter(item => {
                            return row.organizationId === item.value
                        })[0];
                        return <div>{clientItem ? clientItem.label : '--'}</div>
                    }
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'orgWarehouseCode'
                    // render: (h, { row }) => {
                    //     let warehouseItem = this.warehouseList.filter(item => {
                    //         return item.value === row.orgWarehouseId
                    //     })[0];
                    //     return <div>{warehouseItem ? warehouseItem.label : '--'}</div>
                    // }
                },
                {
                    title: this.$t('fbb.expresspackage.service_code', { defaultValue: '承运商' }),
                    render: (h, { row }) => {
                        let carrierItem = this.getCarrierAll.filter(item => {
                            return item.value === row.carrierCode
                        })[0];
                        return (
                            <div>{carrierItem ? carrierItem.label : '--'}</div>
                        )
                    }
                },
                {
                    title: this.$t('fbb.carrieraccount.carrier_group', { defaultValue: '物流产品' }),
                    key: 'carrierGroupName',
                },
                {
                    title: this.$t('erp.b2c.hippingMethodCode', { defaultValue: '物流服务' }),
                    key: 'carrierServiceCode',
                    render: (h, { row }) => {
                        return <div>{row.carrierServiceCode}({row.carrierServiceName})</div>
                    }
                },
                {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    render: (h, { row }) => {
                        return <div>{row.status === 0 ? 'Active' : 'InActive'}</div>
                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    // width: 130
                }
            ];
        },

    }

};
